'use strict';

import '../../css/components/slider.scss';
import { sliderElements } from "./elements/sliderElements";

export default class Slider {
    slider = null;
    sliderImages = null;
    sliderNav = null;
    toLeft = null;
    toRight = null;
    index = 0;
    id = null;
    boundSliders = [];

    constructor(id, boundSliders = []) {
        this.id = id;
        this.elements = sliderElements(id);
        this.boundSliders = boundSliders;
        this.resizeTimer = null;

        this.toRightEvent = this.onToRight.bind(this);
        this.toLeftEvent = this.onToLeft.bind(this);
        this.navDown = this.onNavDown.bind(this);
        this.resize = this.onResize.bind(this);
        this.close = this.onClose.bind(this);
        this.open = this.onOpen.bind(this);
        this.onEsc = this.onEsc.bind(this);

        this.initializeSlider();
    }

    addEventListeners() {
        window.addEventListener('resize', this.resize);
        if (this.elements.toLeft !== null) {
            this.elements.toLeft.addEventListener('mousedown', this.toLeftEvent);
        }
        if (this.elements.toRight !== null) {
            this.elements.toRight.addEventListener('mousedown', this.toRightEvent);
        }
        if (this.elements.closeButton !== null) {
            this.elements.closeButton.addEventListener('mousedown', this.close);
        }
        if (this.elements.imageThumbs !== null) {
            for (let imageThumb of this.elements.imageThumbs) {
                imageThumb.addEventListener('mousedown', this.open);
            }
        }
    }

    initializeSlider() {
        // Only init if we have slides
        if (typeof this.elements.sliderImages[this.index] !== 'undefined') {
            this.addEventListeners();
            this.elements.sliderImages[this.index].style.opacity = '1';
            this.elements.sliderImages[this.index].style.left = '10%';
            this.elements.slider.style.height = `${this.elements.sliderImages[this.index].getBoundingClientRect().height}px`;
            if (this.elements.sliderNav !== null) {
                for (let block of this.elements.sliderNavBlocks) {
                    block.addEventListener('mousedown', this.navDown);
                }
                this.elements.sliderNavBlocks[0].style.opacity = '1';
                this.centerSliderNav();
            }
        }
    }

    centerSliderNav() {
        let totalWidth = 0;
        for (let element of this.elements.sliderNavBlocks) {
            totalWidth += element.getBoundingClientRect().width;
        }
        this.elements.sliderNav.style.marginLeft = `-${totalWidth/2}px`;
    }

    nextAndPrevIndex(index) {
        return {
            next: index === this.elements.sliderImages.length-1 ? 0 : index+1,
            prev: index === 0 ? this.elements.sliderImages.length-1 : index-1
        };
    }

    activateSliderNavBlock(index) {
        if (this.elements.sliderNav !== null) {
            for (let i in this.elements.sliderNavBlocks) {
                if (this.elements.sliderNavBlocks.hasOwnProperty(i)) {
                    this.elements.sliderNavBlocks[i].style.opacity = null;
                }
            }
            this.elements.sliderNavBlocks[index].style.opacity = '1';
        }
    }

    onToLeft(time) {
        this.boundSliders.map(boundSlider => {
            boundSlider.onToLeft(time);
        });

        let transitionTime = '.3s';
        if (typeof time === 'number') {
            transitionTime = `${time}s`;
        }
        const nextPrev = this.nextAndPrevIndex(this.index);

        // Move prev into right position
        this.elements.sliderImages[nextPrev.prev].style.transition = 'none';
        this.elements.sliderImages[nextPrev.prev].style.left = '-100%';
        this.elements.sliderImages[nextPrev.prev].style.opacity = '0';

        // Move current to left
        this.elements.sliderImages[this.index].style.transition = `all ${transitionTime} ease`;
        this.elements.sliderImages[this.index].style.left = '100%';
        this.elements.sliderImages[this.index].style.opacity = '0';

        this.elements.slider.style.height = `${this.elements.sliderImages[nextPrev.prev].getBoundingClientRect().height}px`;

        // Move next to left
        setTimeout(() => {
            this.elements.sliderImages[nextPrev.prev].style.transition = `all ${transitionTime} ease`;
            this.elements.sliderImages[nextPrev.prev].style.left = '10%';
            this.elements.sliderImages[nextPrev.prev].style.opacity = '1';
        });

        this.index--;
        if (this.index < 0) {
            this.index = this.elements.sliderImages.length - 1;
        }
        this.activateSliderNavBlock(this.index);
    }

    onToRight(time) {

        this.boundSliders.map(boundSlider => {
            boundSlider.onToRight(time);
        });

        let transitionTime = '.3s';
        if (typeof time === 'number') {
            transitionTime = `${time}s`;
        }
        const nextPrev = this.nextAndPrevIndex(this.index);

        // Move next into left position
        this.elements.sliderImages[nextPrev.next].style.transition = 'none';
        this.elements.sliderImages[nextPrev.next].style.left = '100%';
        this.elements.sliderImages[nextPrev.next].style.opacity = '0';

        // Move current to right
        this.elements.sliderImages[this.index].style.transition = `all ${transitionTime} ease`;
        this.elements.sliderImages[this.index].style.left = '-100%';
        this.elements.sliderImages[this.index].style.opacity = '0';
        this.elements.slider.style.height = `${this.elements.sliderImages[nextPrev.next].getBoundingClientRect().height}px`;

        // Move next to left
        setTimeout(() => {
            this.elements.sliderImages[nextPrev.next].style.transition = `all ${transitionTime} ease`;
            this.elements.sliderImages[nextPrev.next].style.left = '10%';
            this.elements.sliderImages[nextPrev.next].style.opacity = '1';
        });
        this.index++;
        if (this.index > this.elements.sliderImages.length - 1) {
            this.index = 0;
        }
        this.activateSliderNavBlock(this.index);
    }

    adjustHeight() {
        this.elements.slider.style.height =
            `${this.elements.sliderImages[this.index].getBoundingClientRect().height}px`;
    }

    onResize(event) {
        this.resizeTimer = setTimeout(() => {
            this.adjustHeight();
            clearTimeout(this.resizeTimer);
            this.resizeTimer = null;
        },200);
    }

    moveRight(targetIndex) {
        // move right
        const times = targetIndex - this.index;
        for (let i = 0 ; i < times ; i++) {
            setTimeout(() => {
                this.onToRight(.1);
            }, i * 100);
        }
    }

    moveLeft(targetIndex) {
        // move left
        const times = this.index - targetIndex;
        for (let i = 0 ; i < times ; i++) {
            setTimeout(() => {
                this.onToLeft(.1);
            }, i * 100);
        }
    }

    onNavDown(event) {
        const targetIndex = this.elements.sliderNavBlocks.indexOf(event.currentTarget);
        if (targetIndex > this.index) {
            this.moveRight(targetIndex);
        }
        if (targetIndex < this.index) {
            this.moveLeft(targetIndex);
        }
    }

    onClose(event) {
        event.preventDefault();
        this.elements.lightboxContainer.classList.add('hidden');
        window.removeEventListener('keydown', this.onEsc)
    }

    onEsc(event) {
        if(event.keyCode === 27) {
            this.close(event);
        }
    }

    onOpen(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const targetIndex = Array.prototype.indexOf.call(
            target.parentElement.parentElement.children,
            target.parentElement
        );
        this.elements.lightboxContainer.classList.remove('hidden');
        this.initializeSlider();
        if (targetIndex > this.index) {
            this.moveRight(targetIndex);
        }
        if (targetIndex < this.index) {
            this.moveLeft(targetIndex);
        }

        window.addEventListener('keydown', this.onEsc)
    }
}
